import { useState, useEffect, useContext, useCallback, useMemo } from "react";
import { Button, Backdrop, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import { DataGrid, jaJP } from "@mui/x-data-grid";
import { API, CSV_COMBINATION, PAGE_SIZE, MSG } from "./constantsFront";
import * as React from 'react';
import _ from 'lodash';
import { MsgContext } from "../../App";
//import { AuthInfoContext } from "./AuthContextProvider.tsx";
import { CSVLink } from "react-csv";
import { useDropzone } from "react-dropzone";
import Encoding from "encoding-japanese";
import CSVReader from 'react-csv-reader'

/**
 * 組み合わせ
 * @returns 
 */
function G0216EuCombinationList() {
    const [pageSize, setPageSize] = useState(PAGE_SIZE);
    const [CombinationRows, setCombinationRows] = useState([]); // 組み合わせ

    const { msg, setMsg } = useContext(MsgContext);// エラーメッセージ
    const [selectedFile, setSelectedFile] = useState(); // 選択したファイル
    const [fileData, setFileData] = useState(); // 選択したファイルデータ
    const [csvErrorMsg, setCsvErrorMsg] = useState([]); // CSVアップロードエラーメッセージ
    const [isLoading, setIsLoading] = useState(false);  // Loading
    const navigate = useNavigate();
    let body = { authKey: API.API_KEY };

    // CSVヘッダ
    const csvHeader = [
        { label: "Eナンバー", key: "e_number" },
        { label: "グループ名称", key: "group_name" },
        { label: "食品カテゴリーナンバー", key: "food_category_number" },
        { label: "グループ", key: "group" },
        { label: "最大値(適宜mg/ lまたはmg/ kg)", key: "maximum_value" },
        { label: "脚注ナンバー", key: "footnote_number" },
        { label: "制約/例外", key: "constraint_exception" },
    ];

    useEffect(() => {
        displayData();
    }, [])

    // 表示データ用
    function displayData() {
        // 組み合わせ一覧取得

        body.selectMode = "csv"
        axios.post("/m_eu_combination/select", body).then(res => {
            // 取得チェック
            if (res.status != 200) {
                return;
            }

            let CombinationList = res.data.dataList;
            let rowsData = [];
            for (let i in CombinationList) {
                rowsData.push({
                    id: i
                    , e_number: CombinationList[i].e_number
                    , group_name: CombinationList[i].group_name
                    , food_category_number: CombinationList[i].food_category_number
                    , group: CombinationList[i].group
                    , maximum_value: CombinationList[i].maximum_value
                    , footnote_number: CombinationList[i].footnote_number
                    , constraint_exception: CombinationList[i].constraint_exception
                });
            }
            setCombinationRows(rowsData);
        }).catch(error => {
            console.log('error:', error);
            setMsg(MSG.EXCEPTION);
        });
    }

    // ヘッダー
    const FoodCategoryColumns = [
        { field: "e_number", headerName: "Eナンバー", width: 150 },
        { field: "group_name", headerName: "グループ名称", width: 300 },
        { field: "food_category_number", headerName: "食品カテゴリーナンバー", width: 150 },
        { field: "group", headerName: "グループ", width: 200 },
        { field: "maximum_value", headerName: "最大値(適宜mg/ lまたはmg/ kg)", width: 300 },
        { field: "footnote_number", headerName: "脚注ナンバー", width: 200 },
        { field: "constraint_exception", headerName: "制約/例外", width: 400 },
        // {
        //     field: "edit", headerName: "", sortable: false, disableClickEventBubbling: true, width: 50,
        //     renderCell: (params) => <Tooltip title="表示" arrow><IconButton ><RemoveRedEyeIcon /></IconButton></Tooltip>
        // },
    ];

    // CSVファイルを選択時trueを設定
    const changeHandlerCsv = (event) => {
        setSelectedFile(event.target.files[0]);
        event.target.value = '';
    };

    // ファイル選択ボタン
    const onDrop = useCallback((acceptedFiles) => {
        setSelectedFile(acceptedFiles[0]);
    }, []);
    const { open, acceptedFiles } = useDropzone({
        accept: {
            'text/csv': [],
        },
        multiple: false,
        onDrop,
        noClick: true
    });
    const files = useMemo(() =>
        acceptedFiles.map((file) => (
            <li style={{ listStyleType: "none" }} key={file.path}>
                {file.path}
            </li>
        )
        ), [acceptedFiles]);

    // CSVアップロードボタン
    const handleFiles = files => {
        try {

            setFileData();
            setSelectedFile();
            setCsvErrorMsg([]);
            if (!selectedFile) {
                return setMsg("ファイルを選択してください");
            }

            let reader = new FileReader();
            reader.readAsArrayBuffer(selectedFile);

            reader.onload = async function (e) {
                let uniqueList = [];
                let csletr = [];

                const codes = new Uint8Array(e.target.result);
                const encoding = Encoding.detect(codes);
                const unicodeString = Encoding.convert(codes, {
                    to: 'unicode',
                    from: encoding,
                    type: 'string',
                });

                // 改行ごとに配列化（ダブルクォート内の改行は無視する）
                let delimiter = ',';
                var rowRegex = /(?:(?:"[^"]*")*[^\r\n"]*)+/g,
                    colRegex = new RegExp('(?:(?:"[^"]*")*[^' + delimiter + '"]*)+', 'g'),
                    row, cells, cell, rowMaches, colMaches;

                // 1行ごとに処理
                while ((rowMaches = rowRegex.exec(unicodeString)) !== null) {
                    if (rowMaches[0] == '') {
                        rowRegex.lastIndex++;
                        continue;
                    }
                    //現在の行数
                    let line = csletr.length + 1;

                    // 必須チェックエラーカウント
                    var csvError = 0;

                    cells = [];
                    row = rowMaches[0];
                    while ((colMaches = colRegex.exec(row)) !== null) {
                        cell = colMaches[0].replace(/^\s+|\s+$/g, '');
                        if (cell.charAt(0) == '"' && cell.charAt(cell.length - 1) == '"') {
                            cell = cell.slice(1, -1);
                        }
                        cell = cell.replace(/""/g, '"');
                        cells.push(cell);
                        colRegex.lastIndex++;
                    }

                    //CSVの中身が正しい場合
                    if (cells.length == 7) {

                        uniqueList.push(cells[0]);
                        csletr.push(cells);

                        let i = csletr.length - 1;
                        // 必須チェック開始
                        if (csletr[i][CSV_COMBINATION.E_NUMBER] == '') {
                            csvError++;
                            csvErrorMsg.push(line + "行目 : Eナンバーは必須です。");
                        }

                        if (csletr[i][CSV_COMBINATION.GROUP_NAME] == '') {
                            csvError++;
                            csvErrorMsg.push(line + "行目 : グループ名称は必須です。");
                        }

                        if (csletr[i][CSV_COMBINATION.CATEGORY_NUMBER] == '') {
                            csvError++;
                            csvErrorMsg.push(line + "行目 : 食品カテゴリーナンバーは必須です。");
                        }

                        if (csletr[i][CSV_COMBINATION.GROUP] == '') {
                            csvError++;
                            csvErrorMsg.push(line + "行目 : グループは必須です。");
                        }

                        if (csvError > 0) {
                            return setMsg(csvErrorMsg.join('<br />'));
                        }

                        // 必須チェック終了

                    } else {
                        return setMsg("項目の数が正しくありません。");
                    }
                    rowRegex.lastIndex++;
                }

                console.log("CSVのチェックが終わりました。");

                // Loading
                setIsLoading(true);

                let arrStr = JSON.stringify(csletr);
                body.arrStr = arrStr

                const res1 = await axios.post("/m_eu_combination/upload/auth", body);
                if (res1.status === 200) {
                    displayData();
                    alert("アップロードに成功しました。");
                    setIsLoading(false);
                }
            }
        } catch (err) {
            setIsLoading(false);
            setMsg("登録に失敗しました。");
            return;
        }
    }

    return (
        <>
            <div class="mainLinkMenu"></div>
            <div id="homeContents">
                <div class="homeContentsInner">
                    <div class="mainCont">
                        <div class="selectSearchArea">

                            <Container maxWidth="lg" id="container">
                                {/* Loading */}
                                <Backdrop open={isLoading}
                                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                                    <CircularProgress />
                                </Backdrop>

                                <Stack spacing={2}>
                                    <h1>組み合わせ</h1>
                                    <Stack spacing={2} direction="row">
                                        <Button href="./G0211FoodAdditive"
                                            style={{
                                                width: "200px"
                                                , color: "white"
                                                , textDecoration: "none"
                                            }}>
                                            戻る
                                        </Button>

                                        <CSVLink style={{ color: "white", textDecoration: "none" }}
                                            filename={"組み合わせ.csv"} headers={csvHeader} data={CombinationRows}>
                                            <Button
                                                style={{ width: "200px" }}>CSVダウンロード
                                            </Button>
                                        </CSVLink>
                                    </Stack>
                                    <Stack spacing={2} direction="row">

                                        <Button style={{ width: "200px" }} variant="contained" component="label" onChange={changeHandlerCsv}>
                                            CSVファイルを選択
                                            <CSVReader
                                                inputStyle={{ display: "none" }}
                                                onFileLoaded={(data, fileInfo, originalFile) => setFileData(data)}
                                            />
                                        </Button>
                                        {selectedFile != null ? (
                                            <>
                                                <div>
                                                    <p>ファイル名: {selectedFile.name}</p>
                                                </div>
                                                <Button
                                                    style={{ width: "200px" }}
                                                    onClick={handleFiles}
                                                >
                                                    登録実行
                                                </Button>
                                            </>
                                        ) : (
                                            <div><p>CSVファイルが選択されていません</p></div>
                                        )}

                                    </Stack>

                                    <div style={{ width: "100%" }}>
                                        <DataGrid
                                            className="DataGrid"
                                            columns={FoodCategoryColumns}
                                            rows={CombinationRows}
                                            autoHeight
                                            disableSelectionOnClick
                                            pageSize={pageSize}
                                            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                            pagination
                                            localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
                                        />
                                    </div>


                                </Stack>
                            </Container>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default G0216EuCombinationList;